import React, { Component } from "react";
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button, 
  Glyphicon, 
  Modal, 
  Tooltip, 
  OverlayTrigger,
  Col
 } from "react-bootstrap";
import LoaderButton from "../../components/LoaderButton";
import { invokeApig } from "../../libs/awsLib";
import "./NewUnit.css";
import "../../react-select.min.css";
import Tag from "../tag/Tag";

export class NewUnit extends Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      isLoading: null,
      show: false,
      internalNumber:'',
      licensePlate:'',
      vin: '',
      brand: '',
      model: '',
      year: '',
      speedLimit: '',
      status: ''
    };
  }

  validateForm() {
	  return this.state.internalNumber.length > 0 && this.state.licensePlate.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  updateUnit(unit) {
    return invokeApig({
      path: `/unit`,
      method: "PUT",
      body: unit
    });
  }

  //Método que Obtiene los datos del propietario seleccionado por id
  getUnit() {
    return invokeApig({
      path: `/unit/${this.props.unitId}`
    });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleEdit = async event =>{
    event.preventDefault();
    try {
      const results = await this.getUnit();
      this.setState({ ...results, show: true });
    } catch (e) {
      this.props.onAlertError({ message: "Error al consultar datos del vehículo!" });
    }
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      await this.updateUnit({
        id: this.props.unitId,
        internalNumber: this.state.internalNumber,
        licensePlate: this.state.licensePlate,
        vin: this.state.vin,
        brand: this.state.brand,
        model: this.state.model,
        year: this.state.year,
        speedLimit: this.state.speedLimit,
        status: this.state.status
      });
      this.props.onAlertSuccess({ message: "Vehículo actualizado exitosamente!" });
      this.handleClose();
    } catch (e) {
      this.props.onAlertError({ message: "Error al guardar vehículo! Por favor revise los datos e intente nuevamente." });
    }
    this.setState({ isLoading: false });
  }

  renderFormNew(){
    return(
	  <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup controlId="internalNumber">
          <Col componentClass={ControlLabel} sm={3}>
            Número interno{' '}
            <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al código asignado al vehículo.</Tooltip>}>
              <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
            </OverlayTrigger>
          </Col>
          <Col sm={9}>
            <FormControl
	          onChange={this.handleChange}
	          value={this.state.internalNumber}
	          placeholder="Ingrese solo texto"
	        />
          </Col>
        </FormGroup>
        <FormGroup controlId="licensePlate">
          <Col componentClass={ControlLabel} sm={3}>
            Patente{' '}
            <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde a la patente.</Tooltip>}>
              <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
            </OverlayTrigger>
          </Col>
          <Col sm={9}>
            <FormControl
              onChange={this.handleChange}
              value={this.state.licensePlate}
              placeholder="Ingrese solo texto"
            />
          </Col>
        </FormGroup>
        
        <FormGroup controlId="vin">
	      <Col componentClass={ControlLabel} sm={3}>
	        VIN{' '}
	        <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al identificador único.</Tooltip>}>
	          <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
	        </OverlayTrigger>
	      </Col>
	      <Col sm={9}>
	        <FormControl
	          onChange={this.handleChange}
	          value={this.state.vin}
	          placeholder="Ingrese solo texto"
	        />
	  	  </Col>
	    </FormGroup>
        <FormGroup controlId="brand">
	      <Col componentClass={ControlLabel} sm={3}>
	        Marca{' '}
	        <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde a la marca comercial.</Tooltip>}>
	          <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
	        </OverlayTrigger>
	      </Col>
	      <Col sm={9}>
	        <FormControl
	          onChange={this.handleChange}
	          value={this.state.brand}
	          placeholder="Ingrese solo texto"
	        />
	  	  </Col>
	    </FormGroup>
        <FormGroup controlId="model">
	      <Col componentClass={ControlLabel} sm={3}>
	        Modelo{' '}
	        <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al modelo de la marca.</Tooltip>}>
	          <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
	        </OverlayTrigger>
	      </Col>
	      <Col sm={9}>
	        <FormControl
	          onChange={this.handleChange}
	          value={this.state.model}
	          placeholder="Ingrese solo texto"
	        />
	  	  </Col>
	    </FormGroup>
        <FormGroup controlId="year">
	      <Col componentClass={ControlLabel} sm={3}>
	        Año{' '}
	        <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al año del modelo.</Tooltip>}>
	          <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
	        </OverlayTrigger>
	      </Col>
	      <Col sm={9}>
	        <FormControl
	          onChange={this.handleChange}
	          value={this.state.year}
	          placeholder="Ingrese solo números"
	        />
	  	  </Col>
	    </FormGroup>
	    <FormGroup controlId="speedLimit">
	      <Col componentClass={ControlLabel} sm={3}>
	        Límite de velocidad{' '}
	        <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al límite de velocidad del vehículo.</Tooltip>}>
	          <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
	        </OverlayTrigger>
	      </Col>
	      <Col sm={9}>
	        <FormControl
	          onChange={this.handleChange}
	          value={this.state.speedLimit}
	          placeholder="Ingrese solo números"
	        />
	  	  </Col>
	    </FormGroup>
        <FormGroup controlId="status">
          <Col componentClass={ControlLabel} sm={3}>
            Estado{' '}
            <OverlayTrigger overlay={<Tooltip id="modal-tooltip">Corresponde al estado actual.</Tooltip>}>
              <a tabIndex="-1"><Glyphicon glyph="info-sign"/></a>
            </OverlayTrigger>
          </Col>
          <Col sm={9}>
            <FormControl componentClass="select" onChange={this.handleChange} value={this.state.status} >
              <option value="">Selecciona...</option>
              <option value="Activo">Activo</option>
              <option value="Inactivo">Inactivo</option>
              <option value="Dado de baja">Dado de baja</option>
            </FormControl>
          </Col>
        </FormGroup>
        <Tag/>
        
        <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              type="submit"
              isLoading={this.state.isLoading}
              text="Modificar"
              loadingText="Guardando…"
            />
      </Form>
    );
  }

  render() {
  const tooltipEdit = (<Tooltip id="tooltipEdit"><strong>Modificar</strong></Tooltip>);
    return (
      <div>
        <OverlayTrigger placement="top" overlay={tooltipEdit}>
        <Button onClick={this.handleEdit}>
          <Glyphicon glyph="edit"/>
        </Button>
        </OverlayTrigger>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Datos del vehículo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderFormNew()}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Cerrar</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default NewUnit


// WEBPACK FOOTER //
// ./src/containers/unit/NewUnit.js